import React, { FC, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { FdrProductType } from '@hotelplan/supergraph-api';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import { IFdrProductRecommenderProduct } from 'components/domain/fdr-page-components/recommenders/product/fdr-product-recommender.types';
import useFdrPageComponentsFetch from 'components/domain/fdr-page-components/useFdrPageComponentsFetch';
import { FdrProductRouteMap } from 'components/domain/fdr-product-route-map';
import { FdrGeoProductsDocument } from 'schemas/query/geo/fdr-geo-products.generated';
import {
  createGeoProductVariables,
  mapFdrGeoProductResponseToRecommenderProducts,
} from './fdr-geo.utils';

const GeoProductMapContainer = styled.div(
  sx2CssThemeFn({
    marginTop: [0, '-28px'],
    display: 'flex',
    flexDirection: 'revert',
  })
);

const GEO_MAP_PRODUCT_LIMIT = 1000;

interface IFdrGeoMap {
  id: string;
}

const FdrGeoMap: FC<IFdrGeoMap> = ({ id }) => {
  const [products, setProducts] = useState<IFdrProductRecommenderProduct[]>([]);

  const mapVariables = useCallback(
    (page, perPage) => {
      return createGeoProductVariables(id, page, perPage, [
        FdrProductType.AdventureTravel,
      ]);
    },
    [id]
  );

  const { fetchItems } = useFdrPageComponentsFetch(
    FdrGeoProductsDocument,
    mapVariables,
    mapFdrGeoProductResponseToRecommenderProducts
  );

  useEffect(() => {
    fetchItems(0, GEO_MAP_PRODUCT_LIMIT).then(result =>
      setProducts(result.items.filter(p => p.routePoints?.length))
    );
  }, []);

  return (
    <GeoProductMapContainer>
      <FdrProductRouteMap id={id} products={products} />
    </GeoProductMapContainer>
  );
};

export default FdrGeoMap;
